import React from 'react';

import { CSSObject } from '@emotion/styled';

import { primaryColor } from '@zego/theme';

import View from '@zego/components/atoms/View';

interface Props extends React.ComponentProps<typeof View> {
  backgroundColor?: CSSObject['backgroundColor'];
  children: React.ReactNode;
  size: CSSObject['height'] | CSSObject['width'];
}

function CircleBackground({
  backgroundColor = primaryColor(11),
  children,
  size,
  ...props
}: Props): JSX.Element {
  return (
    <View
      {...props}
      css={{
        borderRadius: '50%',
        justifyContent: 'center',
        display: 'flex',
        alignItems: 'center',
        backgroundColor,
        height: size,
        width: size,
      }}
    >
      {children}
    </View>
  );
}

export default CircleBackground;
